import { createApiError } from '~/domain/errors';

/** Catch-all for BE copy the specific typed errors do not match. */
export class ForgotPasswordApiError extends createApiError('ForgotPasswordApiError') {}
